// Add your custom JS here.

jQuery(document).ready(function() {
    jQuery('.collapse').on('shown.bs.collapse', function() {
        if (location.hash) {
            jQuery(location.hash).show();
        }
    
        var thisId = jQuery(this).attr("id");
        var thisOffsetTop = jQuery("#" + thisId).offset().top;
        var headerHeight = jQuery(".navbar").height();
        var myTitleHeight = jQuery(".container h1").first().height();
    
        console.log(thisId);
        console.log("thisOffsetTop: " + thisOffsetTop);
        console.log("headerHeight: " + headerHeight);
        console.log("MyTitleHeight: " + myTitleHeight);
    
        // Animation to scrollTo the right position
        jQuery('html, body').animate({
            scrollTop: thisOffsetTop - headerHeight - myTitleHeight
        });
    });
    
               
     });          
    
    
    
    jQuery('#loop-town').slick({
        arrows: false,
        autoplay: false,
        autoplaySpeed: 0,
      speed: 9000,
     cssEase: 'linear',
        slidesToShow: 3,
        slidesToScroll: 1,
        variableWidth: true,
        pauseOnFocus:false,
        pauseOnHover:false,
        responsive: [
        
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
    
      ]
        
    });          
              
    setTimeout( function(){
      jQuery( '#loop-town' ).slick( 'play' );
    }, 3000 );